<template>
  <div class="index">
    <Navbar />
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from 'components/Events/Navbar'
import router from '../../router'

export default {
  name: 'Events',
  data () {
    return {
    }
  },
  created () {
    if (!this.$route.params.id && (this.$route.name === 'EventsList' || this.$route.name === 'AllEvents')) {
      router.push('/events/list')
    }
  },
  components: { Navbar }
}
</script>



// WEBPACK FOOTER //
// Events.vue?5b0b61f9